// ProviderPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./ViasatProvider.css";
import provider1 from "../../Includes/Images/world-bg.jpg";
import provider2 from "../../Includes/Images/col-md-3.png";
import provider3 from "../../Includes/Images/col-md-3-1.png";
import provider4 from "../../Includes/Images/col-md-3-2.png";
import provider5 from "../../Includes/Images/col-md-3-3.png";
import provider6 from "../../Includes/Images/background.jpg";
import heroBackground from "../../Includes/Images/Group-1000004732-4.png";
import WideCoverage from './WideCoverage';

const ViasatProvider = () => {
  const { providerName } = useParams();
  
  // Format phone number for accessibility
  const phoneNumber = "+18442172287";
  const formattedPhone = "+1-888-348-6689";

  return (
    <>
      <Header />
      <div className="viasatContainer">
        {/* Header with logo */}
        <header className="viasatHeader">
          <div className="viasatLogo">
            <span>Viasat<sup>TM</sup></span>
            <small>Empowered Frontiers</small>
          </div>
        </header>

        {/* Hero section */}
        <section className="viasatHero" style={{ backgroundImage: `url(${heroBackground})` }}>
          <div className="viasatHeroContent">
            <h1>UNLIMITED HIGH-SPEED SATELLITE INTERNET</h1>
            <p>with no data caps or contracts</p>
            <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call for service">
              <span>{formattedPhone}</span>
            </a>
          </div>
          <div className="viasatHeroImage">
            {/* Image is handled via CSS background in the parent element */}
          </div>
        </section>

        {/* Features section */}
        <section className="viasatFeatures">
          <div className="viasatFeatureGrid">
            <div className="viasatFeature">
              <div className="viasatFeatureIcon" aria-hidden="true">∞</div>
              <h3>Unlimited Data</h3>
              <p>Browse, shop, stream all you want without worrying about data caps</p>
            </div>
            <div className="viasatFeature">
              <div className="viasatFeatureIcon" aria-hidden="true">⟩⟩</div>
              <h3>Fast & reliable</h3>
              <p>Get a reliable and consistent internet experience</p>
            </div>
            <div className="viasatFeature">
              <div className="viasatFeatureIcon" aria-hidden="true">📄</div>
              <h3>No contract</h3>
              <p>Enjoy month-to-month service with no long-term commitment</p>
            </div>
          </div>
        </section>

        {/* Sustainability section */}
        <section className="viasatSustainability">
          <div className="viasatSustainabilityContent">
            <h2>Keeping space safe, sustainable, and equitable</h2>
            <p>See how Viasat and others are calling on policy makers around the world to keep space safe, sustainable, and equitable for science, exploration, and communications.</p>
            <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call for more information">
              <span>{formattedPhone}</span>
            </a>
          </div>
          <div className="viasatSustainabilityImage">
            <img src={provider1} alt="Earth from space with lights" />
          </div>
        </section>

        {/* Industries section */}
        <section className="viasatIndustries">
          <h2>Industries We Serve</h2>
          <p>Viasat is always finding better ways to connect people, businesses, governments, and communities.</p>
          
          <div className="viasatIndustryGrid">
            <div className="viasatIndustryCard">
              <img src={provider2} alt="Home Internet" />
              <h3>Home Internet</h3>
              <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call about home internet">
                <span>{formattedPhone}</span>
              </a>
            </div>
            <div className="viasatIndustryCard">
              <img src={provider3} alt="Small Business Internet" />
              <h3>Small Business Internet</h3>
              <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call about business internet">
                <span>{formattedPhone}</span>
              </a>
            </div>
            <div className="viasatIndustryCard">
              <img src={provider4} alt="Aviation" />
              <h3>Aviation</h3>
              <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call about aviation services">
                <span>{formattedPhone}</span>
              </a>
            </div>
            <div className="viasatIndustryCard">
              <img src={provider5} alt="Defense" />
              <h3>Defense</h3>
              <a href={`tel:${phoneNumber}`} className="viasatButton" aria-label="Call about defense services">
                <span>{formattedPhone}</span>
              </a>
            </div>
          </div>
        </section>

        {/* Installation section */}
        <section className="viasatInstallation">
          <div className="viasatInstallationImage">
            <img src={provider6} alt="Satellite tower" />
          </div>
          <div className="viasatInstallationContent">
            <h2>Professional satellite internet installation for peace of mind</h2>
            <p>From her remote cabin in the woods, Leslie Murray stays connected with her reliable, high-speed satellite internet plan.</p>
            <ul>
              <li>Stream music</li>
              <li>Use Wi-Fi calling</li>
              <li>Manage parts of her business remotely</li>
            </ul>
          </div>
        </section>
      </div>
      <WideCoverage/>
      <Footer />
    </>
  );
};

export default ViasatProvider;